/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const MCPAuthType = {
  Bearer: "bearer",
  Authorization: "authorization",
  Headers: "headers",
  None: "none",
} as const;
export type MCPAuthType = ClosedEnum<typeof MCPAuthType>;

/** @internal */
export const MCPAuthType$inboundSchema: z.ZodNativeEnum<typeof MCPAuthType> = z
  .nativeEnum(MCPAuthType);
/** @internal */
export const MCPAuthType$outboundSchema: z.ZodNativeEnum<typeof MCPAuthType> =
  MCPAuthType$inboundSchema;
